:host {
  display: block;
}

@media screen and (min-width: 768px) {
  .alignment-right {
    justify-content: flex-end;
  }
}
